import { useReactiveVar } from '@apollo/client';
import { Result, Typography } from 'antd';
import { currentPermissionsVar } from 'api/cache';
import { useCurrentUser } from 'operations/queries/queryCurrentUser';
import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route } from 'react-router';
// THÊM IMPORT
import { SCREEN_PERMISSIONS } from 'appConstants';

const PrivateRoute = ({ children, isLoggedIn, path, keyCode, ...props }) => {
  // Chúng ta vẫn dùng useReactiveVar ở đây để các component khác có thể dùng,
  // nhưng logic của PrivateRoute sẽ không phụ thuộc vào nó nữa.
  useReactiveVar(currentPermissionsVar);
  
  const { loading, error, data: currentUserData } = useCurrentUser();

  if (loading || !currentUserData) {
    return <Typography.Text>Loading...</Typography.Text>;
  }

  if (error)
    return (
      <Result
        status="500"
        title="500"
        subTitle="Hệ thống đang bảo trì, vui lòng quay lại sau."
      />
    );

  // LOGIC MỚI: Tính toán quyền trực tiếp từ data
  const userType = currentUserData?.detail?.userType;
  const derivedPermissions = SCREEN_PERMISSIONS[userType] || [];

  const render = () => {
    // THAY ĐỔI: Sử dụng `derivedPermissions` thay cho `currentPermissions`
    if (derivedPermissions)
      switch (true) {
        case derivedPermissions.includes(keyCode):
        case path === '/404':
        case path === '/unauthorized':
        case path === '/':
        case path === '/danh-sach-bai-tin':
        case path === '/chi-tiet-tin-bai/:id?':
        case path === '/ca-nhan/:id':
        case path === '/ca-nhan':
          return (
            <Route path={path} {...props}>
              {isLoggedIn ? children : <Redirect exact to="/dang-nhap" />}
            </Route>
          );

        default:
          return <Redirect to="/unauthorized" />;
      }
    else {
      // Trường hợp này gần như không xảy ra, nhưng để an toàn
      return <Redirect to="/unauthorized" />;
    }
  };

  return render();
};

PrivateRoute.propTypes = {
  children: PropTypes.any,
  isLoggedIn: PropTypes.bool,
  path: PropTypes.string,
  keyCode: PropTypes.string
};

export default PrivateRoute;